import React from "react";

import { AlertProps, Alert as MuiAlert } from "@mui/material";
import { styled } from "@mui/styles";
import { spacing } from "@mui/system";

const AlertRaw: React.VFC<AlertProps> = (props) => {
  return <MuiAlert {...props} />;
};

export const Alert = styled(AlertRaw)(spacing);
